const getUserData = ({ db, currentUser }) => {
    return new Promise(async (resolve, reject) => {
        try {
            var user = await db.get({ path: `users/${currentUser.uid}` });

            // if we don't find the user go back to the 
            if (user) {
                const organization = await db.get({ path: `organizations/${user.organization}` });

                resolve({user, organization});
            }
            else {
                console.log(`User ${currentUser.uid} not found`);
            }
        }
        catch (error) {
            reject(error);
        }
    })
}

export {
    getUserData
}